export { NgTranscludeDirective } from './transclude.directive';
export { TabDirective } from './tab.directive';
export { TabHeadingDirective } from './tab-heading.directive';
export { TabsetComponent } from './tabset.component';
export { TabsetConfig } from './tabset.config';
export { TabsModule } from './tabset.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/tabs-pills/index.ts